module.exports = __webpack_public_path__ + "static/img/cqc.5cac2248.jpg";